<template>
  <div class="login">
    <div class="l_box" v-if="!completeFlag">
      <div class="lb_left">
        <img src="../assets/img/i1.svg" />
        <img src="../assets/img/i11.png" />
      </div>
      <div class="lb_right">
        <div class="lbr_top">账户登录</div>
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="教师登录" name="teacher"></el-tab-pane>
          <el-tab-pane label="学生登录" name="student"></el-tab-pane>
          <el-tab-pane label="研训登录" name="teachingResearch"></el-tab-pane>
        </el-tabs>
        <div class="lbr_center" v-if="activeName == 'teacher'">
          <div class="brc_item">
            <div class="rci_left">
              <img class="cil_icon" src="@/assets/img/l2.png" />
              手机号
            </div>
            <input placeholder="请输入手机号" type="number" maxlength="11" v-model="phone" />
          </div>
          <div class="brc_item">
            <div class="rci_left">
              <img class="cil_icon" src="@/assets/img/l3.png" />
              验证码
            </div>
            <div class="rci_right">
              <input placeholder="请输入验证码" type="number" maxlength="6" v-model="code" />
              <div class="rci_right_btn" @click="getCode">{{ count >= 0 ? count + 's' : '获取验证码' }}</div>
            </div>
          </div>
        </div>

        <div class="lbr_center" v-if="activeName == 'student'">
          <div class="brc_item">
            <div class="rci_left">
              <img class="cil_icon" src="@/assets/img/s1.png" />
              课堂编号
            </div>
            <input placeholder="请输入课堂编号" v-model="studentInfo.techCourseId" />
          </div>
          <div class="brc_item">
            <div class="rci_left">
              <img class="cil_icon" src="@/assets/img/s2.png" />
              学号
            </div>
            <input placeholder="请输入学号" v-model="studentInfo.stdNo" />
          </div>
          <div class="brc_item">
            <div class="rci_left">
              <img class="cil_icon" src="@/assets/img/s3.png" />
              密码
            </div>
            <input placeholder="请输入密码" type="password" v-model="studentInfo.password" />
          </div>
        </div>

        <div class="lbr_center" v-if="activeName == 'teachingResearch'">
          <div class="brc_item">
            <div class="rci_left">
              <img class="cil_icon" src="@/assets/img/s1.png" />
              教研编号
            </div>
            <input placeholder="请输入教研编号" v-model="teachingResearchInfo.techCourseId" />
          </div>
          <div class="brc_item">
            <div class="rci_left">
              <img class="cil_icon" src="@/assets/img/s2.png" />
              账号
            </div>
            <input placeholder="请输入账号" v-model="teachingResearchInfo.stdNo" />
          </div>
          <div class="brc_item">
            <div class="rci_left">
              <img class="cil_icon" src="@/assets/img/s3.png" />
              密码
            </div>
            <input placeholder="请输入密码" type="password" v-model="teachingResearchInfo.password" />
          </div>
        </div>

        <div class="lbr_bottom">
          <div class="brb_btn" @click="submit">登录/注册</div>
          <div class="brb_xy" @click="isXy = !isXy">
            <img :src="!isXy ? require('@/assets/img/i14.png') : require('@/assets/img/i15.png')" />
            <div>
              登录即同意<span>《用户服务协议》</span> 、<span>《隐私政策》</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="r_box" v-if="completeFlag">
      <div class="rb_top">
        <div class="rbt_left">完善信息</div>
        <el-upload :headers="myHeaders" :http-request="handleUploadImgForm" :on-change="imgSaveToUrl"
          :show-file-list="false" action class="upload-demo" multiple accept="image/*">
          <div class="rbt_right">
            <img class="btr_img" :src="info.avatar ? webImg + info.avatar : require('../assets/img/i45.png')" />
            <img class="btr_icon" src="../assets/img/i46.png" />
          </div>
        </el-upload>
      </div>
      <div class="rb_center">
        <div class="rbc_item">
          <div class="bci_left"><span>*</span>姓名</div>
          <div class="bci_right">
            <el-input placeholder="请输入您的姓名" v-model="info.nickName"></el-input>
          </div>
        </div>
        <div class="rbc_item">
          <div class="bci_left"><span>*</span>手机号</div>
          <div class="bci_right">
            <el-input placeholder="请输入您的手机号" disabled v-model="info.phone"></el-input>
          </div>
        </div>
        <div class="rbc_item">
          <div class="bci_left"><span>*</span>任教学段</div>
          <div class="bci_right">
            <el-select v-model="info.techSectionId" placeholder="请选择您的任教学段" @change="sectionChange">
              <el-option v-for="item in sectionList" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="rbc_item">
          <div class="bci_left"><span>*</span>当前职务</div>
          <div class="bci_right">
            <el-select multiple v-model="info.techPostId" placeholder="请选择您的当前职务">
              <el-option v-for="item in jobList" :key="item.id" :label="item.techPost" :value="item.id">
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="rbc_item">
          <div class="bci_left"><span>*</span>任教科目</div>
          <div class="bci_right">
            <el-select v-model="info.techSubjectId" placeholder="请选择您的任教科目">
              <el-option v-for="item in subjectList" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="rbc_item">
          <div class="bci_left">所在学校</div>
          <div class="bci_right">
            <el-input placeholder="请输入您的所在学校" v-model="info.techSchool"></el-input>
          </div>
        </div>
        <div class="rbc_item" style="width: 100%;">
          <div class="bci_left">地区</div>
          <div class="bci_right">
            <el-cascader placeholder="请选择所在地区" v-model="info.address" :options="multiArray"
              @change="handleChange"></el-cascader>
          </div>
        </div>
      </div>
      <div class="rb_bottom" @click="infoUpdateDate">提交</div>
    </div>
    <div class="copyright">
      <div>Copyright © 2024 成都七米牛网络科技有限责任公司</div>
      <a href="https://beian.miit.gov.cn/" target="_blank">蜀ICP备2024095961号-1</a>
    </div>
  </div>

</template>

<script>
import axios from 'axios'
import {
  codeLogin,
  sendCode,
  userInfo,
  sectionSubject,
  areaCascaderList,
  techPostListBySectionId,
  completeUserInfo,
  ossToken,
  teachingResearchLogin,
  classroomTestLogin
} from '@/apis/index'
export default {
  data() {
    return {
      activeName: this.$route.query.activeName || 'teacher',
      phone: '',
      code: '',
      count: -1,
      timer: '',
      isXy: true,
      completeFlag: false,
      info: {
        avatar: '',
        nickName: '',
        phone: '',
        techSectionId: '',
        // techPost: '',
        techSubjectId: '',
        techSchool: '',
        provinceId: '', //省份ID
        provinceName: '', //省份名称
        cityName: '', //城市名称
        cityId: '', //城市ID
        districtId: '', //区县ID
        districtName: '', //区县名称
        address: '', //省市区显示
        addrInfo: '',
        techPostId: '', //职务ids
      },
      sectionList: [],
      sectionIndex: null,

      jobList: [],
      jobIndex: 0,

      subjectList: [],
      subjectIndex: null,

      multiIndex: [0, 0, 0],
      multiArray: [],
      array: [],
      num: 'label',

      isFlag: 0,

      myHeaders: { "X-Token": ossToken() },

      teachingResearchInfo: {
        techCourseId: '',
        stdNo: '',
        password: '123456'
      },
      studentInfo: {
        password: '123456',
        stdNo: '',
        techCourseId: ''
      }
    }
  },
  created() {

  },
  mounted() {
    // this.getInfo()
  },
  methods: {
    handleClick() {

    },
    infoUpdateDate() {
      if (!this.info.avatar) {
        return this.$message.warning('请上传头像')
      }
      if (!this.info.nickName) {
        return this.$message.warning('请输入姓名')
      }
      if (!this.info.phone) {
        return this.$message.warning('请输入手机号码')
      }
      if (!this.info.techPostId) {
        return this.$message.warning('请选择当前职务')
      }
      if (!this.info.techSubjectId) {
        return this.$message.warning('请选择任教科目')
      }
      if (!this.info.techSectionId) {
        return this.$message.warning('请选择任教学段')
      }
      this.info.techPostId = this.info.techPostId.join(',')
      completeUserInfo(this.info).then(res => {
        console.log(res, 'completeUserInfo');
        this.$router.replace('/dialogue')
      })
    },
    handleUploadImgForm(param) {
      console.log(param, 'imgup');
      const formData = new FormData();
      formData.append("multipart", param.file);
      let loading = this.$loading({
        lock: true,
        text: "上传中，请稍候...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      // 获取上传token
      ossToken(param.file.name).then(res => {
        let ossRes = JSON.parse(res.data);
        console.log(ossRes, 'getOssToken')
        const ossData = new FormData();
        Object.keys(ossRes).forEach((key) => {
          ossData.append(key, ossRes[key]);
        });
        console.log(param.file, 'param.file')
        ossData.append("file", param.file);
        var url = ossRes.host;
        axios({
          headers: {
            'Content-Type': 'multipart/form-data',
          },
          method: 'post',
          url: url,
          data: ossData
        }).then(async (res2) => {
          console.log(res2, 'getOssToken axios')
          this.info.avatar = res2.data.url
          loading.close();
        })
      })
    },
    // 选取图片后自动回调，里面可以获取到文件
    imgSaveToUrl(event) {
      console.log(event, 'eventOnchange');
    },
    sectionChange(e) {
      console.log(e, 'e');
      this.subjectList = this.sectionList[e - 1].subjectList
      this.getJobList()
    },
    handleChange(value) {
      console.log(value);
      this.info.provinceId = value[0]
      this.info.cityId = value[1]
      this.info.districtId = value[2]
      console.log(this.info);
    },
    getJobList() {
      techPostListBySectionId(this.info.techSectionId).then(res => {
        console.log(res, 'techPostListBySectionId');
        this.jobList = res.data
      })
    },
    getAddressList() {
      areaCascaderList().then(res => {
        console.log(res, 'areaCascaderList');
        this.multiArray = res.data
        // this.multiArray = this.transformData(res.data)
        console.log(this.multiArray, 'array');
      })
    },
    //学段 科目
    getSectionAndSubjectList() {
      sectionSubject(2).then(res => {
        console.log(res, 'getSectionAndSubjectList');
        this.sectionList = res.data
      })
    },
    getInfo() {
      userInfo().then(res => {
        console.log(res, 'userInfo');
        this.info = res.data
        this.getSectionAndSubjectList()
        this.getAddressList()
      })
    },
    submit() {
      if (this.activeName == 'teacher') {
        if (!this.phone || this.phone.length != 11) {
          return this.$message.error('请输入手机号')
        }
        if (!this.code || this.code.length != 6) {
          return this.$message.error('请输入短信验证码')
        }
        if (!this.isXy) {
          return this.$message('请阅读协议后并勾选')
        }
        codeLogin({
          code: this.code,
          phone: this.phone,
          loginType: 2
        }).then(res => {
          console.log(res, 'codeLogin');
          localStorage.setItem('token', res.data.token)
          localStorage.setItem('loginType', 1)
          this.$store.dispatch('updateUserInfo', JSON.stringify(res.data, (key, value) => {
            if (key != 'token') {
              return value
            }
            return undefined
          }));
          // this.$router.replace('/dialogue')

          if (!res.data.completeFlag) {
            this.completeFlag = true
            this.getInfo()
          } else {
            this.$router.replace('/dialogue')
          }
        })
      }
      if (this.activeName == 'student') {
        if (!this.studentInfo.techCourseId) {
          return this.$message.error('请输入课堂编号')
        }
        if (!this.studentInfo.stdNo) {
          return this.$message.error('请输入学号')
        }
        if (!this.studentInfo.password) {
          return this.$message.error('请输入密码')
        }
        if (!this.isXy) {
          return this.$message('请阅读协议后并勾选')
        }
        classroomTestLogin(this.studentInfo).then(res => {
          console.log(res, 'classroomTestLogin');
          localStorage.setItem('token', res.data.token)
          localStorage.setItem('loginType', 2)
          this.$store.dispatch('updateUserInfo', JSON.stringify(res.data, (key, value) => {
            if (key != 'token') {
              return value
            }
            return undefined
          }));
          this.$router.replace('/student/studentHomePage')
        })
      }
      if (this.activeName == 'teachingResearch') {
        if (!this.teachingResearchInfo.techCourseId) {
          return this.$message.error('请输入教研编号')
        }
        if (!this.teachingResearchInfo.stdNo) {
          return this.$message.error('请输入账号')
        }
        if (!this.teachingResearchInfo.password) {
          return this.$message.error('请输入密码')
        }
        if (!this.isXy) {
          return this.$message('请阅读协议后并勾选')
        }
        teachingResearchLogin(this.teachingResearchInfo).then(res => {
          console.log(res, 'teachingResearchLogin');
          localStorage.setItem('token', res.data.token)
          localStorage.setItem('loginType', 3)
          this.$store.dispatch('updateUserInfo', JSON.stringify(res.data, (key, value) => {
            if (key != 'token') {
              return value
            }
            return undefined
          }));
          this.$router.replace('/teachingResearch/teachingResearchHomePage')
        })
      }

    },
    getCode() {
      if (!this.phone) {
        return this.$message('手机号不能为空')
      }
      if (this.count == -1 || this.count == 0 || this.count == null) {
        sendCode(1, this.phone).then(res => {
          console.log(res, 'sendCode');
          if (this.count <= 0) {
            this.$message({ type: 'success', message: '短信验证码已发送，请注意查收' })
            this.timer_();
          }
        })
      }
    },
    timer_() {
      const TIME_COUNT = 60;
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
          } else {
            this.count--;
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      }
    }
  },
}
</script>

<style lang="scss" scoped>
::v-deep {
  .el-tabs__item {
    background-color: #fff;
  }

  .el-select {
    width: 100% !important;
  }

  .el-cascader {
    width: 100% !important;
  }
}

.login {
  width: 100%;
  min-height: 100vh;
  background: #F3F5FA;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .copyright {
    position: absolute;
    bottom: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: 12px;
    color: #999999;

    a {
      color: #999999;
      text-decoration: none;
      margin-top: 5px;

      &:hover {
        color: #5AA7F7;
      }
    }
  }

  .r_box {
    width: 1200px;
    height: 659px;
    display: flex;
    align-items: center;
    flex-direction: column;
    background-color: #fff;
    border-radius: 24px;
    box-shadow: 0px 14px 44px 0px rgba(162, 192, 221, 0.1), 0px 2px 10px 0px #D8E4F0;
    box-sizing: border-box;
    padding: 40px 80px;

    .rb_top {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .rbt_left {
        font-weight: bold;
        font-size: 30px;
        color: #252525;
      }

      .rbt_right {
        width: 72px;
        height: 72px;
        position: relative;
        cursor: pointer;

        .btr_img {
          width: 100%;
          height: 100%;
          border-radius: 6px;
        }

        .btr_icon {
          width: 20px;
          height: 20px;
          position: absolute;
          bottom: 0%;
          right: 0%;
          // transform: translate(-50%,-50%);
        }
      }
    }

    .rb_center {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex-wrap: wrap;

      .rbc_item {
        width: 500px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 50px;

        .bci_left {
          width: 100px;
          text-align: right;
          font-weight: bold;
          font-size: 16px;
          color: #252525;

          span {
            font-weight: 500;
            font-size: 16px;
            color: #FF0000;
          }
        }

        .bci_right {
          flex: 1;
          margin-left: 10px;
        }
      }
    }

    .rb_bottom {
      width: 200px;
      height: 52px;
      background: #2992FF;
      border-radius: 8px 8px 8px 8px;
      font-weight: bold;
      font-size: 20px;
      color: #FFFFFF;
      text-align: center;
      line-height: 52px;
      margin-top: 50px;
      cursor: pointer;
    }
  }

  .l_box {
    width: 1200px;
    height: 659px;
    display: flex;
    align-items: center;
    background-color: #fff;
    border-radius: 24px;
    box-shadow: 0px 14px 44px 0px rgba(162, 192, 221, 0.1), 0px 2px 10px 0px #D8E4F0;


    .lb_left {
      width: 50%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      img:nth-child(1) {
        width: 397px;
        height: 85px;
      }

      img:nth-child(2) {

        width: 225px;
        height: 289px;
        margin-top: 70px;
      }
    }

    .lb_right {
      width: 50%;
      height: 100%;
      box-sizing: border-box;
      padding: 0 60px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      -webkit-app-region: no-drag;

      .lbr_top {
        font-weight: bold;
        font-size: 24px;
        color: #000000;
        margin-bottom: 30px;
      }

      .lbr_center {
        width: 100%;

        .brc_item {
          width: 440px;
          height: 50px;
          border-bottom: 1px solid #ececec;
          display: flex;
          align-items: center;
          margin-top: 20px;

          .rci_left {
            width: 80px;
            white-space: nowrap;
            display: flex;
            align-items: center;
            font-weight: bold;
            font-size: 14px;
            color: #333333;

            .cil_icon {
              width: 14px;
              height: 14px;
              margin-right: 5px;
            }
          }

          .rci_right {
            flex: 1;
            display: flex;
            align-items: center;

            input {
              // flex: 1;
              width: 150px;
              font-size: 16px;
              margin: 0 10px;
            }

            .rci_right_btn {
              white-space: nowrap;
              font-weight: bold;
              font-size: 16px;
              color: #5AA7F7;
              cursor: pointer;
            }
          }

          input {
            flex: 1;
            font-size: 16px;
            margin: 0 10px;
          }
        }
      }

      .lbr_bottom {
        width: 100%;

        .brb_btn {
          width: 100%;
          height: 52px;
          background: #5AA7F7;
          box-shadow: 0px 6px 15px 0px rgba(29, 151, 239, 0.21);
          border-radius: 8px;
          font-weight: bold;
          font-size: 18px;
          color: #FFFFFF;
          text-align: center;
          line-height: 52px;
          margin-top: 60px;
          cursor: pointer;
        }

        .brb_xy {
          width: 100%;
          display: flex;
          align-items: center;
          margin-top: 40px;
          cursor: pointer;

          img {
            width: 20px;
            height: 20px;
          }

          div {
            flex: 1;
            margin-left: 10px;
            font-weight: 400;
            font-size: 12px;
            color: #666666;

            span {
              color: #5AA7F7;

            }
          }

        }
      }

    }
  }
}
</style>
